import React from 'react';
import { FaEdit, FaTrashAlt } from 'react-icons/fa';

interface DetailHeaderProps {
  title: string;
  handleEdit?: () => void; // Type for the edit function (void return type)
  handleDelete?: () => void; // Optional delete function (void return type)
  createdAt?: string;
  updatedAt?: string;
  createdBy?: string;
  updatedBy?: string;
  canWrite?: boolean;
}

const DetailHeader: React.FC<DetailHeaderProps> = ({
  title,
  handleEdit,
  handleDelete,
  createdAt,
  updatedAt,
  createdBy,
  updatedBy,
  canWrite,
}) => {
  const lastUpdated = updatedAt ?? createdAt;
  const lastUpdatedDate = lastUpdated ? new Date(lastUpdated).toLocaleString() : 'N/A';
  return (
    <div className="header-section">
      <div className="header-top-row">
        <h1 className="form-title">{title}</h1>
        <div className="header-button-group">
          {handleEdit &&
            (canWrite ? (
              <button onClick={handleEdit} title="Edit">
                <FaEdit />
              </button>
            ) : (
              <span title="User doesn't have write permission">
                <button disabled className="disabled-button">
                  <FaEdit />
                </button>
              </span>
            ))}
          {handleDelete &&
            (canWrite ? (
              <button onClick={handleDelete} title="Delete">
                <FaTrashAlt />
              </button>
            ) : (
              <span title="User doesn't have write permission">
                <button disabled className="disabled-button">
                  <FaTrashAlt />
                </button>
              </span>
            ))}
        </div>
      </div>
      <div className="header-meta">
        Created by: {createdBy}
        {updatedBy && ` | Updated by: ${updatedBy}`}
        {' | Last Updated: '}
        {lastUpdatedDate}
      </div>
    </div>
  );
};

export default DetailHeader;
